import { render, staticRenderFns } from "./StaffCarousel.vue?vue&type=template&id=7e5fbb38&scoped=true&"
import script from "./StaffCarousel.vue?vue&type=script&lang=js&"
export * from "./StaffCarousel.vue?vue&type=script&lang=js&"
import style0 from "./StaffCarousel.vue?vue&type=style&index=0&id=7e5fbb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5fbb38",
  null
  
)

export default component.exports